module.exports = __webpack_public_path__ + "static/media/apartment19.fe1da66b.jpg";